var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4367 6.18013C14.4367 8.97575 12.748 11.375 10.4992 11.375C8.24871 11.375 6.56171 8.97575 6.56171 6.17925C6.56171 3.3845 8.01421 1.75 10.4992 1.75C12.9842 1.75 14.4367 3.38363 14.4367 6.18013ZM3.58846 17.6243C3.92534 18.025 5.37609 19.25 10.4992 19.25C15.6223 19.25 17.0722 18.025 17.41 17.6251C17.4413 17.5867 17.4644 17.5423 17.478 17.4946C17.4915 17.4469 17.4952 17.3969 17.4887 17.3477C17.4117 16.576 16.717 13.125 10.4992 13.125C4.28146 13.125 3.58671 16.576 3.50884 17.3477C3.5025 17.397 3.5063 17.447 3.51999 17.4947C3.53368 17.5424 3.55698 17.5859 3.58846 17.6243Z",
    fill: "#145165"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.1c534dfebfae44263b619257a6f196c1.svg";
export { ForwardRef as ReactComponent };